import { ActionType, ModeModalAction, OpenSidebarAction, ToggleSidebarAction } from './types';

export const modeModal = (isModeModal: boolean): ModeModalAction => ({
  type: ActionType.modeModal,
  isModeModal,
});

export const toggleSidebar = (): ToggleSidebarAction => ({
  type: ActionType.toggleSidebar,
});

export const openSidebar = (): OpenSidebarAction => ({
  type: ActionType.openSidebar,
});
